// Southern California map bounds and shared constants

export const SOCAL_BOUNDS = {
    south: 32.53,
    west: -121.0,
    north: 35.80,
    east: -114.5
};

export const SOCAL_CENTER = {
    lat: 32.7157,
    lng: -117.1611
};

export const SOCAL_RESTRICTION = {
    latLngBounds: SOCAL_BOUNDS,
    strictBounds: true
};

export const SOCAL_AUTOCOMPLETE_BOUNDS = {
    south: SOCAL_BOUNDS.south,
    west: SOCAL_BOUNDS.west,
    north: SOCAL_BOUNDS.north,
    east: SOCAL_BOUNDS.east
};

export function isWithinSoCalBounds(lat: number, lng: number): boolean {
    return (
        lat >= SOCAL_BOUNDS.south &&
        lat <= SOCAL_BOUNDS.north &&
        lng >= SOCAL_BOUNDS.west &&
        lng <= SOCAL_BOUNDS.east
    );
}
